import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, AlertTriangleIcon, TrashIcon } from 'lucide-react';
export function DeleteAccount() {
  const [formState, setFormState] = useState({
    email: '',
    reason: '',
    confirmed: false
  });
  const [submitted, setSubmitted] = useState(false);
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!formState.confirmed) return;
    const subject = encodeURIComponent(`Account Deletion Request — ${formState.email}`);
    const body = encodeURIComponent(`Account email: ${formState.email}\n\nReason (optional): ${formState.reason || 'Not provided'}\n\nI confirm that I want my Pawchi account and all associated data permanently deleted.`);
    window.location.href = `mailto:privacy@pawchi.app?subject=${subject}&body=${body}`;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  }
  return <div className="min-h-screen bg-cream" data-id="element-922" data-mp="27f9ycn9csay6">
      <div className="max-w-2xl mx-auto px-6 pt-32 pb-20" data-id="element-923" data-mp="upcoyswfykfj">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-924" data-mp="unrsuyuhatfk">
          <ArrowLeftIcon size={18} data-id="element-925" data-mp="lq97tugu4f3o" />
          Back to Home
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-3" data-id="element-926" data-mp="qnrhxo6l90d9">
          Delete your account
        </h1>
        <p className="text-warmBrown/60 text-lg mb-10" data-id="element-927" data-mp="1eewxe28m9qn1">
          Request the permanent deletion of your Pawchi account and all
          associated data.
        </p>

        {/* Warning callout */}
        <div className="bg-peach/10 border border-peach/30 rounded-2xl p-5 mb-8 flex gap-3" data-id="element-928" data-mp="14emj0eauid6a">
          <AlertTriangleIcon size={22} className="text-peach flex-shrink-0 mt-0.5" data-id="element-929" data-mp="19dpmvvf3adco" />
          <div className="text-warmBrown/80 text-sm leading-relaxed" data-id="element-930" data-mp="3p4buqig95iur">
            <p className="font-bold mb-2" data-id="element-931" data-mp="3u59n1nuz7t9z">This action is permanent.</p>
            <p className="mb-3" data-id="element-932" data-mp="3a2vjq97gojem">
              When your account is deleted, the following data will be
              permanently removed within 30 days:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-933" data-mp="36239bcmus8gr">
              <li data-id="element-934" data-mp="319s0fka4xcc2">Your profile and account information</li>
              <li data-id="element-935" data-mp="3188htn10ap74">Your pet companions and their progress</li>
              <li data-id="element-936" data-mp="2wap72x3ioujx">All habit, mood, and breathing session history</li>
              <li data-id="element-937" data-mp="2rcx3v6xf9m0f">Photos and any uploaded content</li>
              <li data-id="element-938" data-mp="2rdowc8vq33mh">Settings and preferences</li>
            </ul>
            <p className="mt-3 text-warmBrown/60" data-id="element-939" data-mp="2mc9cul971567">
              Some anonymized data may be retained as required by law (e.g. for
              tax and audit purposes).
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" data-id="element-940" data-mp="2ddxmmkc8o9ea">
          <div data-id="element-941" data-mp="gkvxemn8z68d">
            <label htmlFor="email" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-942" data-mp="gjb1otp75h8x">
              Account email
            </label>
            <input id="email" type="email" placeholder="The email associated with your Pawchi account" required value={formState.email} onChange={e => setFormState({
            ...formState,
            email: e.target.value
          })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" data-id="element-943" data-mp="j5aemnbwc40n" />
          </div>

          <div data-id="element-944" data-mp="a2iywbbzmm37">
            <label htmlFor="reason" className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-945" data-mp="a2sssa05lde6">
              Reason for leaving (optional)
            </label>
            <textarea id="reason" placeholder="Help us improve — let us know why you're deleting your account" rows={4} value={formState.reason} onChange={e => setFormState({
            ...formState,
            reason: e.target.value
          })} className="w-full px-4 py-3 rounded-xl bg-white border border-warmBrown/10 text-warmBrown placeholder:text-warmBrown/30 focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors resize-none" data-id="element-946" data-mp="1llbz0pkopr6t" />
          </div>

          <label className="flex items-start gap-3 cursor-pointer p-4 rounded-xl bg-white border border-warmBrown/10 hover:border-warmBrown/20 transition-colors" data-id="element-947" data-mp="223zyvi9cy0gd">
            <input type="checkbox" required checked={formState.confirmed} onChange={e => setFormState({
            ...formState,
            confirmed: e.target.checked
          })} className="mt-1 w-4 h-4 accent-peach" data-id="element-948" data-mp="2gu75n0q05v18" />
            <span className="text-sm text-warmBrown/80 leading-relaxed" data-id="element-949" data-mp="34gsuz7idrd49">
              I understand that this action is permanent and cannot be undone. I
              want my Pawchi account and all associated data to be deleted.
            </span>
          </label>

          <button type="submit" disabled={!formState.confirmed} className="px-8 py-4 rounded-full font-bold text-white bg-peach hover:bg-peach/90 disabled:bg-warmBrown/20 disabled:cursor-not-allowed transition-colors shadow-soft-lg flex items-center gap-2" data-id="element-950" data-mp="30dwatcd6z8y7">
            {submitted ? 'Opening email client...' : <>
                <TrashIcon size={16} data-id="element-951" data-mp="2gpdr3aaygnqw" />
                Request account deletion
              </>}
          </button>
        </form>

        <p className="mt-8 text-sm text-warmBrown/50 leading-relaxed" data-id="element-952" data-mp="22r5y1dh1i6l0">
          You can also request deletion directly from within the app under{' '}
          <span className="font-medium text-warmBrown/70" data-id="element-953" data-mp="d9sck86y8of1">
            Settings → Account → Delete account
          </span>
          . Requests are typically processed within 7 business days.
        </p>
      </div>
    </div>;
}